// extracted by mini-css-extract-plugin
export var logo = "Header-module--logo--7bOtT";